import { HStack, Text, VStack } from '@chakra-ui/react';
import ProviderAvatar from '@/components/services/directory/ProviderAvatar';

interface SuggestionOptionProps {
	/** Who this is, on the first line. */
	label: string;
	/** How to reach them, on the second: the address, or nothing where the record holds none. */
	detail?: string;
}

/**
 * One person in a suggestion list, drawn the way the app draws a contact everywhere else: a mark,
 * their name, and the address under it.
 *
 * Two lines rather than a name and an address facing each other across the row. The address is what
 * the name is being chosen by when two people share one, so it has to sit with the name rather than
 * at the far edge of a row wide enough to separate them.
 */
const SuggestionOption = ({ label, detail }: SuggestionOptionProps) => (
	<HStack gap={3} minW={0} w="full">
		<ProviderAvatar provider={{ name: label, email: detail ?? null }} size="32px" fontSize="xs" />
		<VStack gap={0} align="start" minW={0}>
			<Text fontSize="sm" truncate maxW="full">
				{label}
			</Text>
			{detail ? (
				<Text fontSize="xs" color="fg.muted" truncate maxW="full">
					{detail}
				</Text>
			) : null}
		</VStack>
	</HStack>
);

export default SuggestionOption;
